import { creditCardRepository } from '@webapp/modules/expense/data-access/repositories/CreditCardRepository'
import { reimbursementSettingsRepository } from '@webapp/modules/expense/data-access/repositories/ReimbursementSettingsRepository'
import { GetExpenseLineItemFormDataUseCase } from './GetExpenseLineItemFormDataUseCase'

export const getExpenseLineItemFormDataUseCase =
  new GetExpenseLineItemFormDataUseCase({
    reimbursementSettingsRepository,
    creditCardRepository,
  })

export { GetExpenseLineItemFormDataUseCase } from './GetExpenseLineItemFormDataUseCase'
